var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgMetaNotConnected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1652,
    viewBox: "0 0 1920 1652",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2787_969)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1652,
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2787_969)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2787_969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1608.86 1296.79C2238.5 952.5 1877.77 1411.71 1925 1627C1693 1730.53 996.561 1792.4 884.553 1781.4C742.925 1638.82 818.411 1732.37 884.554 1718.88C1039.61 1687.24 1069.7 1326.03 1237.5 1342.5C1393.07 1357.77 1508.34 1393.75 1608.86 1296.79Z",
    fill: "url(#paint0_linear_2787_969)",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2787_969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.891 1319.18C-127.502 1512.87 -293.388 1428.54 1.95754 1764.71C216.954 1900.05 201.361 1646.8 313.797 1651.78C474.195 1530.7 912.208 1832.79 848.644 1810.07C699.632 1756.78 1095.05 1345.04 926.606 1337.58C828.567 1319.52 577.916 1184.02 336.891 1319.18Z",
    fill: "url(#paint1_linear_2787_969)",
    fillOpacity: 0.8
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2787_969",
    x: 624.216,
    y: 992.771,
    width: 1541.43,
    height: 969.889,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 90,
    result: "effect1_foregroundBlur_2787_969"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2787_969",
    x: -345.736,
    y: 1059.84,
    width: 1514.96,
    height: 951.449,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_2787_969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2787_969",
    x1: 830.336,
    y1: 1677.31,
    x2: 1813.02,
    y2: 1130.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B9B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A660FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2787_969",
    x1: 939.271,
    y1: 1876.4,
    x2: 290.936,
    y2: 937.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B9B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.750625,
    stopColor: "#A660FA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2787_969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1652,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2787_969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 589,
    fill: "white",
    transform: "translate(0 1069)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaNotConnected);
export default __webpack_public_path__ + "static/media/meta-not-connected.ad29acf29b973f637bfdf1c9e6e01340.svg";
export { ForwardRef as ReactComponent };